import {Component, Input, Output, EventEmitter} from '@angular/core';
import {ToasterService} from 'angular2-toaster';

@Component({
    selector: 'justwatch-id-fetch-search-results',
    templateUrl: 'justwatch-id-fetch-search-results.component.html',
    styleUrls: ['justwatch-id-fetch-search-results.component.scss']
})
export class JustwatchIdFetchSearchResultsComponent {
    @Input() results = [];
    @Input() searchValue = '';
    @Output() onHandleOpen = new EventEmitter();

    constructor(private toasterService: ToasterService) {
    }

    handleResultCheckbox(result) {
        result.checked = !result.checked;
    }

    handleTableRowClick(result) {
        result.collapsed = !result.collapsed;
    }

    handleOpen(result) {
        const item: any = {
            justwatch_id: result.justwatch_id,
            content_type: result.content_type,
            title: result.originalTitle,
            original_release_date: result.original_release_date,
        };
        this.onHandleOpen.emit(item);
    }

    formatCatalogState(catalogState) {
        return catalogState.split('_').map((item) => {
            return item[0].toUpperCase().concat(item.slice(1));
        }).join(' ');
    }

    copyMessage(val: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.toasterService.pop('info', 'Copied Justwatch ID ' + val);
    }
}



// WEBPACK FOOTER //
// ./src/app/justwatch-id-fetch/justwatch-id-fetch-search-results.component.ts